import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vShow as _vShow, normalizeClass as _normalizeClass, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "innerbox"
};
const _hoisted_2 = {
  class: "imgTxtbox"
};
const _hoisted_3 = {
  class: "imgbox"
};
const _hoisted_4 = ["src"];
const _hoisted_5 = {
  class: "txtbox"
};
const _hoisted_6 = {
  class: "title"
};
const _hoisted_7 = {
  class: "textover"
};
const _hoisted_8 = {
  class: "textover"
};
const _hoisted_9 = {
  class: "textover"
};
const _hoisted_10 = ["href"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _withDirectives((_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["popcontainer-style4", [{
      'rightTop': $data.rightTopflag
    }]])
  }, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("img", {
    src: $data.formUserItem.image,
    alt: ""
  }, null, 8, _hoisted_4), _createElementVNode("span", null, _toDisplayString($data.formUserItem.level), 1)]), _createElementVNode("div", _hoisted_5, [_createElementVNode("h2", _hoisted_6, _toDisplayString(_ctx.$attrs.detail.placeName), 1), _createElementVNode("ul", null, [_createElementVNode("li", null, [_createElementVNode("span", _hoisted_7, "类别：" + _toDisplayString(_ctx.$attrs.detail.mapType), 1)]), _createElementVNode("li", null, [_createElementVNode("span", _hoisted_8, "批次：" + _toDisplayString($data.formUserItem.batch), 1)]), _createElementVNode("li", null, [_createElementVNode("span", _hoisted_9, "申报地区或单位：" + _toDisplayString($options.getAddress(_ctx.$attrs.detail.pca)), 1)])])])]), _createElementVNode("a", {
    class: "more",
    target: "_blank",
    href: $data.formUserItem.gateway
  }, _cache[0] || (_cache[0] = [_createTextVNode("查看详情"), _createElementVNode("i", {
    class: "icon-arrow-bottom1"
  }, null, -1)]), 8, _hoisted_10)])], 2)), [[_vShow, _ctx.$attrs.popshowflag]]);
}